var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2511",
    "data-name": "Rectangle 2511",
    width: 24,
    height: 24,
    transform: "translate(19 339)",
    fill: "none",
    stroke: "#ffc400",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Support",
    transform: "translate(-19 -339)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2178",
    transform: "translate(22.374 1025.04)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2180",
    transform: "translate(0.625 -682.04)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7644",
    "data-name": "Group 7644",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2188",
    transform: "translate(0 2.82)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2190",
    d: "M-159.2-51.975l-.959-.959a1.356,1.356,0,0,0-1.918,0l-.481.481a2.709,2.709,0,0,0-.4,3.329A26.16,26.16,0,0,0-159.2-44.3a26.159,26.159,0,0,0,4.82,3.757,2.708,2.708,0,0,0,3.328-.4l.481-.481a1.356,1.356,0,0,0,0-1.918l-.959-.959a1.258,1.258,0,0,0-1.851-.027,1.392,1.392,0,0,1-1.726.033,24.365,24.365,0,0,1-2.176-1.924A24.365,24.365,0,0,1-159.21-48.4a1.387,1.387,0,0,1,.024-1.714A1.268,1.268,0,0,0-159.2-51.975Z",
    transform: "translate(163.351 53.331)",
    fill: "none",
    stroke: "#ffc400",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2192",
    transform: "translate(4.857)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2194",
    d: "M0-60.96a6.753,6.753,0,0,1,4.363-1.59,6.78,6.78,0,0,1,6.78,6.78,6.752,6.752,0,0,1-1.591,4.364",
    transform: "translate(0 62.551)",
    fill: "none",
    stroke: "#ffc400",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2196",
    transform: "translate(9.22 4.068)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2198",
    d: "M0,0V2.712L1.356,4.068",
    fill: "none",
    stroke: "#ffc400",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/Support.8f93c8a1a13d1fbb54223d6b15f8ef63.svg";
export { ForwardRef as ReactComponent };